import type { Entity } from './contract'

/* ERP · busca de entidades do grafo pelo texto (o ⌘K no servidor, server/admin/search-all.ts, e os testes da paleta).
   Sem React e sem alias: o servidor importa direto. Casa nome, código e lugar; nunca dado pessoal. */

/** Lowercase, no accents, single spaces. */
export function normalize(s: string): string {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim()
}

/** Text the palette matches for an entity: name, code and place (city/UF, place, region). Never personal data. */
function entityHaystack(e: Entity): string[] {
    const r = e as Partial<Record<'code' | 'city' | 'uf' | 'place' | 'region', string | null>>
    return [r.code, r.city, r.uf, r.place, r.region].filter((x): x is string => !!x)
}

/** Match strength of an entity for the query (0 = no match): name start, word start, name, then code/place. */
export function entityScore(e: Entity, query: string): number {
    const q = normalize(query)
    if (q.length < 2) return 0
    const name = normalize(e.name)
    if (name.startsWith(q)) return 100
    if (name.split(' ').some(w => w.startsWith(q))) return 80
    if (name.includes(q)) return 60
    if (entityHaystack(e).some(x => normalize(x) === q)) return 50
    if (entityHaystack(e).some(x => normalize(x).includes(q))) return 30
    if (q.split(' ').length > 1 && q.split(' ').every(w => name.includes(w))) return 40
    return 0
}

/** Graph entities matching the query (from 2 chars), best first (stable for ties). */
export function searchEntities(entities: readonly Entity[], query: string, limit = 12): Entity[] {
    const scored: { e: Entity; s: number; i: number }[] = []
    entities.forEach((e, i) => {
        const s = entityScore(e, query)
        if (s) scored.push({ e, s, i })
    })
    return scored.sort((a, b) => b.s - a.s || a.i - b.i).slice(0, limit).map(x => x.e)
}
